import {Injectable} from "@angular/core";
import {HttpRepository} from "./http.repository";
import {GlobalConfig} from "../configs/GlobalConfig";
import {forkJoin, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {AppEventBus} from "../event-buses/app.event-bus";
import {AppEvent} from "../event-buses/AppEvent";
import {AppEventName} from "../event-buses/AppEventName";

@Injectable()
export class TranslationRepository {

  constructor(private httpRepository: HttpRepository,
              private httpClient: HttpClient,
              private appEventBus: AppEventBus) {

  }

  private getTranslationObject(languageCode: string, type = 'default'): Observable<any> {
    return this.httpRepository.get(`${GlobalConfig.endpoints.translationObject}/${languageCode}/documentType/${type}`);
  }

  private getDefaultStaticTokenTranslationObject(): Observable<any> {
    return this.httpClient.get('/assets/languages/en.json');
  }

  getStaticTokenTranslationObject(languageCode: string) {
    return this.getTranslationObject(languageCode).pipe(
      catchError(() => {
        return this.getDefaultStaticTokenTranslationObject();
      })
    );
  }

  getErrorCodeTranslationObject(languageCode: string) {
    return this.getTranslationObject(languageCode, 'ErrorCode');
  }

  getUnitOfMeasureTranslationObject(languageCode: string) {
    return this.getTranslationObject(languageCode, 'UnitOfMeasure');
  }

  getCompleteTranslationObject(languageCode: string): Observable<any> {
    this.appEventBus.dispatch(new AppEvent(AppEventName.TranslationDownloading, {}));

    return new Observable((observer) => {
      this.getStaticTokenTranslationObject(languageCode).subscribe((staticTranslation) => {
        forkJoin([
          this.getUnitOfMeasureTranslationObject(languageCode),
          this.getErrorCodeTranslationObject(languageCode)
        ]).subscribe({
          next: (results) => {
            observer.next({
              t: staticTranslation,
              uom: results[0],
              ec: results[1]
            });
            observer.complete();
          },
          error: () => {
            observer.next({t: staticTranslation});
            observer.complete();
          }
        });
      });
    });
  }
}
